module.exports = __webpack_public_path__ + "fonts/fa-light-300.1c697cb0c37b13c7293c0de237ed26a0.ttf";